import * as React from "react";
import { styled, alpha } from "@mui/material";

import { makeStyles } from "@mui/styles";
import Color from "color";

export const useStyles = makeStyles((theme) => ({
  paper: {
    backgroundColor: theme.palette.primary.main,

    textAlign: "center",
    padding: theme.spacing(4.65),
    display: "flex",
    width: "100%",
    // justifyContent:"space-around",
  },
  cardContentsWrapper: {

    "& *": {
      margin: theme.spacing(1.5),
    },
  },

  cardHeader: {
    color: theme.palette.primary.contrastText,
    fontWeight: "900",
  },

  cardText: {
    color: alpha(theme.palette.text.tertiary, 0.7),

  },
}));

//   "&:hover, &:focus": {
